import { JSGraph as OriginalJSGraph, peakPicking as originalPeakPicking, } from 'common-spectrum';
import { Spectrum } from 'ms-spectrum';
import { getAnnotations } from "./jsgraph/getAnnotations.js";
export { AnalysesManager, Analysis, toJcamp } from 'common-spectrum';
export { fromText } from "./from/fromText.js";
export { fromJcamp } from "./from/fromJcamp.js";
export function autoPeakPicking(spectrum, options = {}) {
    options = {
        threshold: 0.1,
        numberSlots: 20,
        numberCloseSlots: 40,
        ...options,
    };
    const data = {
        x: spectrum.variables.x.data,
        y: spectrum.variables.y.data,
    };
    const msSpectrum = new Spectrum(data);
    // we need to know the global best peaks to know his intensity and set it to 100
    const minMaxX = msSpectrum.minMaxX();
    const maxY = msSpectrum
        .getBestPeaks({
        ...options,
        from: minMaxX.min,
        to: minMaxX.max,
    })
        .sort((a, b) => b.y - a.y)[0]?.y;
    const maxRatio = maxY ? 100 / maxY : 1;
    const peaks = msSpectrum.getBestPeaks(options);
    return peaks.map((peak) => {
        return {
            mass: peak.x,
            intensity: peak.y * maxRatio,
        };
    });
}
export function peakPicking(spectrum, target) {
    const peak = originalPeakPicking(spectrum, target, {
        xVariable: 'x',
        yVariable: 'y',
        optimize: false,
        // we could optimize the peaks but it depends of the width
        // and also if it is continuous or not. Not obvious
        // if we optimize we need to add this parameters for high res spectrum
        //   shape: { kind: 'gaussian', fwhm: 0.01 },
        max: true,
    });
    if (!peak)
        return undefined;
    return {
        mass: peak.x,
        intensity: peak.y,
    };
}
export const JSGraph = { ...OriginalJSGraph, getAnnotations };
//# sourceMappingURL=index.js.map